<template>
  <div class="jumbotron">
    <loading :active.sync="isLoading"></loading>
    <div class="container-fluid">
      <div class="row top-row-padding">
        <div class="col-lg-6 offset-lg-3 text-center">
          <h2>Search For Your Business</h2>
          <div id="attribution-node"></div>
          <input v-on:keydown.enter="searchBusinesses" v-model="queryString" class="form-control form-control-lg" placeholder="Search Businesses">
          <button class="btn btn-primary" v-on:click="searchBusinesses">Search</button>
          <div class="wrapper">
            <b-alert variant="warning"
              dismissible
              :show="showBusinessIsClaimed"
              @dismissed="showBusinessIsClaimed=false">
              This business is already claimed.
            </b-alert>
            <div v-on:click="cantFindBusiness" class="alert-wrapper">
              <b-alert variant="warning"
                :show="showZeroResults">
                0 results found. <u>Add</u> your business now!
              </b-alert>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-10 offset-lg-1">
          <div class="business-block" v-for="(result, index) in results" v-bind:key="index">
            <h3 v-on:click="preClaim(index)" class="business-name d-inline">{{ result.name }}</h3>
            <p>{{ result.formatted_address }}</p>
          </div>
          <div class="row">
            <div class="col-lg-6 offset-lg-3">
              <button v-if="showButton" class="btn btn-primary" v-on:click="cantFindBusiness">Can't Find Your Business?</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="confirmModal" ref="confirmModal" size="lg" hide-footer>
      <div slot="modal-header" class="w-100 justify-content-center share-modal-header">
        <h3>Claim Business</h3>
        <button v-on:click="hideConfirmModal" class="close d-inline" type="button" aria-label="Close">x</button>
      </div>
      <div class="container">
        <div class="row">
          <div class="col">
            <p>Are you sure you want to claim this business? This cannot be undone without contacting our support team.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 second">
            <button v-on:click="hideConfirmModal" class="btn btn-secondary">Cancel</button>
          </div>
          <div class="col-md-6">
            <button v-on:click="claim(index)" class="btn btn-primary">Confirm</button>
          </div>
        </div>
      </div>
    </b-modal>
    <the-auth-modal ref="authModal"></the-auth-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import GooglePlacesApi from '../../lib/googlePlacesApi.js'
import router from '../../router/index.js'
import TheAuthModal from '../authentication/TheAuthModal.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import mixins from '../GlobalMixins.js'

export default {
  data () {
    return {
      queryString: null,
      results: [],
      showBusinessIsClaimed: false,
      showZeroResults: false,
      showButton: false,
      isLoading: false,
      index: null,
      attributionElement: null,
      zipCode: null
    }
  },
  async mounted () {
    this.attributionElement = document.getElementById('attribution-node')
    var coordinates = await GooglePlacesApi.getLatLong()
    this.zipCode = GooglePlacesApi.unpackPostalCode(await GooglePlacesApi.geocode(coordinates.lat, coordinates.lng))
  },
  components: {
    theAuthModal: TheAuthModal,
    Loading
  },
  computed: {
    ...mapGetters([
      'getIdProvider'
    ]),
    ...mapGetters('user', [
      'getUserType'
    ])
  },
  watch: {
    getUserType: function (newUserType, oldUserType) {
      if (newUserType === 'business') {
        router.replace('/home')
      }
    }
  },
  mixins: [mixins],
  methods: {
    ...mapMutations('user', [
      'updateUserType'
    ]),
    ...mapActions('business', [
      'createBusiness',
      'syncData'
    ]),
    showModal () {
      this.$refs.authModal.$refs.authModal.show()
    },
    async cantFindBusiness () {
      if (!this.getIdProvider) {
        this.showModal()
        return
      }
      try {
        await this.createBusiness()
        this.updateUserType('business')
        router.replace('/profile/business/details/overview')
        await this.syncData()
      } catch (error) {
        console.log(error)
      }
    },
    showConfirmModal () {
      this.$refs.confirmModal.show()
    },
    hideConfirmModal () {
      this.index = null
      this.$refs.confirmModal.hide()
    },
    preClaim (index) {
      if (!this.getIdProvider) {
        this.showModal()
        return
      }
      this.index = index
      this.showConfirmModal()
    },
    async claim (index) {
      this.isLoading = true
      this.hideConfirmModal()
      var businessId = this.results[index].place_id
      try {
        if (await this.businessIsClaimed(businessId)) {
          this.showBusinessIsClaimed = true
        } else {
          await this.claimBusiness(businessId, this.attributionElement)
        }
      } catch (error) {
        console.log(error)
      }
      this.isLoading = false
    },
    async searchBusinesses () {
      if (!this.queryString) return
      this.showBusinessIsClaimed = false
      this.isLoading = true
      try {
        this.results = await GooglePlacesApi.googleSearch(this.attributionElement, this.queryString, this.zipCode)
        this.showZeroResults = false
        this.showButton = true
      } catch (error) {
        if (error === 'ZERO_RESULTS') {
          this.showZeroResults = true
          this.results = []
          this.showButton = true
        } else {
          console.log(error)
        }
      }
      this.isLoading = false
    }
  }
}
</script>

<style scoped>
.jumbotron {
  background-color: #f1f1f1 !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
  margin: 3rem;
}

@media (max-width: 768px) {
  .jumbotron {
    margin: 1rem;
  }
}

.form-control {
  margin-bottom: 1rem;
}

.claim-button {
  width: unset !important;
}

.business-block {
  margin-bottom: 1.5rem;
}

.business-name, .alert-wrapper {
  cursor: pointer;
}

.wrapper {
  padding: 1rem;
}

.close {
  position: absolute;
  text-shadow: none;
  right: .7rem;
  top: .5rem;
  opacity: 1;
}

.btn-secondary {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/claimSearch/ClaimSearch.vue